// material-ui
import {alpha} from '@mui/material/styles';

// ==============================|| DEFAULT THEME - CUSTOM SHADOWS  ||============================== //
const getSoftShadow = (color) => `0 0 40px 0 ${alpha(color, 0.08)}`
const getHardShadow = (color) => `0 0 20px 0 ${alpha(color, 0.1)}`

const CustomShadows = (theme) => {
	return ({
		button: getHardShadow('#0000000b'),
		text: `0 -1px 0 rgb(0 0 0 / 12%)`,
		primary: getHardShadow(theme.palette.primary.main),
		secondary: getHardShadow(theme.palette.secondary.main),
		error: getHardShadow(theme.palette.error.main),
		warning: getHardShadow(theme.palette.warning.main),
		info: getHardShadow(theme.palette.info.main),
		success: getHardShadow(theme.palette.success.main),
		grey: getHardShadow('#1B1D1D'),
		primaryButton: getSoftShadow(theme.palette.primary.main),
		secondaryButton: getSoftShadow(theme.palette.secondary.main),
		errorButton: getSoftShadow(theme.palette.error.main),
		warningButton: getSoftShadow(theme.palette.warning.main),
		infoButton: getSoftShadow(theme.palette.info.main),
		successButton: getSoftShadow(theme.palette.success.main),
		greyButton: getSoftShadow('#1B1D1D')
	})
};

export default CustomShadows;
